module.exports = __webpack_public_path__ + "img/borderLongRadioWhite.96976145.svg";